






import { Vue, Component } from 'vue-property-decorator'
import { TaiwanEnroll } from '@/models/enroll/taiwanStudent'
import { get } from '@/api/enroll/taiwanStudent'
import Printer from './components/taiwan/Printer.vue'
import { alert } from '@/utils/notification'

@Component({
  components: {
    Printer
  }
})
export default class TaiwanStudentDetail extends Vue {
  value: TaiwanEnroll = {
    id: '',
    studentId: '',
    name: '',
    sex: '',
    birthda: '',
    idCard: '',
    taiwanpassId: '',
    taiwanIdCard: '',
    nowSchool: '',
    photoUrl: '',
    nation: '',
    address: '',
    phoneNumber: '',
    mobilPhone: '',
    email: '',
    faxNumber: '',
    firstVolunteer: '',
    secondVolunteer: '',
    thirdVolunteer: '',
    adjustAgree: '',
    school1: '',
    school1Location: '',
    school1StartTime: '',
    school1EndTime: '',
    school1EducationLevel: '',
    school2: '',
    school2Location: '',
    school2StartTime: '',
    school2EndTime: '',
    school2EducationLevel: '',
    school3: '',
    school3Location: '',
    school3StartTime: '',
    school3EndTime: '',
    school3EducationLevel: '',
    registraNo: '',
    candidateNo: '',
    chineseGrade: '',
    chineseLevel: '',
    mathGrade: '',
    mathLevel: '',
    engGrade: '',
    englevel: '',
    socialGrade: '',
    socialLevel: '',
    natureGrade: '',
    natureLevel: '',
    reportCardUrl: '',
    date1: '',
    awardDetails1: '',
    date2: '',
    awardDetails2: '',
    date3: '',
    awardDetails3: '',
    date4: '',
    awardDetails4: '',
    activity1: '',
    activity1TimeRange: '',
    activity1useTime: '',
    activity1Remark: '',
    activity2: '',
    activity2TimeRange: '',
    activity2useTime: '',
    activity2Remark: '',
    activity3: '',
    activity3TimeRange: '',
    activity3useTime: '',
    activity3Remark: '',
    activity4: '',
    activity4TimeRange: '',
    activity4useTime: '',
    activity4Remark: '',
    activity5: '',
    activity5TimeRange: '',
    activity5useTime: '',
    activity5Remark: '',
    activity6: '',
    activity6TimeRange: '',
    activity6useTime: '',
    activity6Remark: '',
    person1: '',
    person1Relation: '',
    person1JobInfo: '',
    person1PhoneNum: '',
    person2: '',
    person2Relation: '',
    person2JobInfo: '',
    person2PhoneNum: '',
    person3: '',
    person3Relation: '',
    person3JobInfo: '',
    person3PhoneNum: '',
    emergencyContact: '',
    emergencyContactRelation: '',
    emergencyContactAddress: '',
    emergencyContactPhoneNumber: '',
    emergencyContactFaXnumber: '',
    emergencyContactEmail: '',
    personalRepresentation: ''
  }

  async created() {
    const id = this.$route.params.id

    try {
      this.value = await get(id)
    } catch (e) {
      alert('获取台湾地区考生入学申请信息失败', e)
    }
  }
}
